import { HttpErrorResponse } from '@angular/common/http';

interface ValidationError {
  errors: { [key: string]: string };
  title: string;
}

export function extractValidationErrors(httpErrorResponse: HttpErrorResponse): string {
  if (httpErrorResponse.error) {
    if ((httpErrorResponse.error as ValidationError).errors) {
      let message = '';
      Object.keys((httpErrorResponse.error as ValidationError).errors).forEach(function (key, _) {
        message += (httpErrorResponse.error as ValidationError).errors[key] + ' \n';
      });
      return message;
    } else {
      return (httpErrorResponse.error as ValidationError).title as string;
    }
  }
  return httpErrorResponse.message;
}
